import axios from 'axios';
import { settings } from "../../../assets/config/settings.js";
const send = async (body) => {
    //console.log(body)
    
    try {
        return await axios.post(`${settings.backendApi}/submit`, body);
    } catch (error) {
        throw error;
    }
};

export default send;